import type { SVGProps } from 'react';

// Oversized decorative emblem behind the main menu.
// Inlined instead of fetched from /public: the markup is part of the first paint
// and costs no extra round trip (see AGENTS.md → Performance).
export function LogoMenuBackground(props: SVGProps<SVGSVGElement>) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="660" height="611" viewBox="0 0 660 611" fill="none" {...props}>
            <path
                d="M314.487 0.0195312L371.127 67.1641L314.487 22.5918V310.964L451.274 226.282L451.275 226.275L513.125 298.823L451.276 248.608V610.82H224.109V62.4707L314.469 0.0126953L314.471 0L314.477 0.00683594L314.487 0V0.0195312ZM137.399 422.723L199.383 465.419L137.399 442.772V610.819H0V508.785L137.387 422.723L137.388 422.715L137.393 422.718L137.399 422.715V422.723ZM659.681 475.829L604.536 435.713V610.817H539.195V487.959L604.536 411.606V411.689L604.544 411.606L659.681 475.829Z"
                fill="black"
                fillOpacity="0.25"
            />
        </svg>
    );
}
